module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/bg-paper-0b1d83c7cf554af4aadc2f583c336886.jpg";